import PropTypes from 'prop-types';
import { Variants as Variants$1 } from '../Input/Input.types.js';

var Variants = Variants$1;
var propTypes = {
    defaultCountry: PropTypes.string,
    testId: PropTypes.string,
    'data-testid': PropTypes.string,
    value: PropTypes.string,
    variant: PropTypes.oneOf([Variants.DEFAULT, Variants.UNDERLINE]),
    label: PropTypes.string,
    countryLabel: PropTypes.string,
    numberLabel: PropTypes.string,
    name: PropTypes.string,
    isValid: PropTypes.bool,
    errorMessage: PropTypes.string,
    className: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    disabled: PropTypes.bool,
    clearable: PropTypes.bool,
    primaryCondition: PropTypes.string,
    secondaryCondition: PropTypes.string,
    relativelyStyledConditions: PropTypes.bool,
    isMultilineSecondaryCondition: PropTypes.bool,
    phoneNumberInputProps: PropTypes.objectOf(PropTypes.any),
    countryCodeDropdownProps: PropTypes.objectOf(PropTypes.any),
};
var defaultProps = {
    variant: Variants.DEFAULT,
    clearable: true,
    defaultCountry: 'US',
    countryLabel: 'Country Code',
    label: 'Phone Number',
};

export { Variants, defaultProps, propTypes };
